import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { BookingProvider } from "@/context/BookingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import LanguageModal from "@/components/LanguageModal";
import "@/i18n";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";

import AdTypeStep from "@/pages/book/AdTypeStep";
import ComposerStep from "@/pages/book/ComposerStep";
import CheckoutStep from "@/pages/book/CheckoutStep";
import DoneStep from "@/pages/book/DoneStep";

import "@/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BookingProvider>
          <ScrollToTop />
          <LanguageModal />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/book" element={<AdTypeStep />} />
            <Route path="/book/compose" element={<ComposerStep />} />
            <Route path="/book/checkout" element={<CheckoutStep />} />
            <Route path="/book/done" element={<DoneStep />} />

            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BookingProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
